import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faCircle } from '@fortawesome/free-solid-svg-icons';
import { getAvailabilityTrend } from '../utils/availabilityTrend';

const ICON = { up: faArrowUp, down: faArrowDown, neutral: faCircle };
const CHIP_COLOR = {
  up: 'text-emerald-600 border-emerald-300 bg-emerald-50',
  down: 'text-rose-600 border-rose-300 bg-rose-50',
  neutral: 'text-gray-500 border-gray-300 bg-gray-50',
};
const ICON_SIZE = { up: 'text-[9px]', down: 'text-[9px]', neutral: 'text-[5px]' };
// Klucze słownika `model`.
const ARIA_LABEL = { up: 'oferta.trend_rosnie', down: 'oferta.trend_maleje', neutral: 'oferta.trend_zmiana' };

const AvailabilityTrend = ({
  availability,
  availability_prev,
  availability_prev_ts,
  availability_prev2,
  availability_prev2_ts,
}) => {
  const { t } = useTranslation('model');
  // Widoczność tooltipa sterowana jawnym stanem (nie samym CSS :hover/:focus-within) —
  // te pseudoklasy potrafią nie zadziałać spójnie na dotyku i w niektórych przeglądarkach,
  // przez co obramówka była widoczna, a treść tooltipa nigdy się nie pokazywała.
  const [visible, setVisible] = useState(false);

  const trend = getAvailabilityTrend({
    availability, availability_prev, availability_prev_ts, availability_prev2, availability_prev2_ts,
  });

  if (!trend.shouldShow || !trend.tooltipText) return null;

  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  return (
    <span
      tabIndex={0}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      onClick={show}
      className={`relative inline-flex h-4 w-4 items-center justify-center rounded-full border cursor-help focus:outline-none focus:ring-2 focus:ring-offset-1 ${CHIP_COLOR[trend.direction]}`}
      aria-label={t(ARIA_LABEL[trend.direction])}
    >
      <FontAwesomeIcon icon={ICON[trend.direction]} className={ICON_SIZE[trend.direction]} />
      <span
        role="tooltip"
        className={`pointer-events-none absolute bottom-full left-1/2 z-20 mb-2 w-max max-w-[220px] -translate-x-1/2 whitespace-pre-line rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-xs font-medium normal-case text-gray-700 shadow-lg transition-opacity duration-150 ${
          visible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {trend.tooltipText}
        <span className="absolute left-1/2 top-full -mt-1 h-2 w-2 -translate-x-1/2 rotate-45 border-b border-r border-gray-200 bg-white" />
      </span>
    </span>
  );
};

export default AvailabilityTrend;
